/* eslint-disable @typescript-eslint/no-explicit-any */
import { ALL_SELECT_LABEL, ALL_SELECT_VALUE } from '../../../utils/constants/global-constants'
import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import { and, isArchivedFilter } from './data'


interface Calendar {
  AssignedComponentCode: null | number | string
  Category: null | string
  Description: string
  EndDate?: string
  Id: string
  IsAllDayEvent: boolean,
  IsArchived: boolean
  ItemCreated: string
  ItemCreatedBy: string
  ItemModified: string
  ItemModifiedBy: string
  Location: null | string
  MAJCOMCode: null | number | string
  RRule: string
  Section: null | string
  SectionCode: null | number | string
  ServicingOrganization: null | string
  StartDate?: string
  Title: string
  eKey: string
  eTag: string
  location: null | string
}
interface CalendarFetchArgs {
  assignedComponentFilter?: null | number | string
  categoryFilter?: null | number | string
  isArchived: false | null | true
  isAscending?: boolean
  orderBy?: string
  sectionFilter?: null | number | string
  servicingMajcomFilter?: null | number | string
}

const COLUMN_NAMES = {
  AssignedComponentCode: 'AssignedComponentCode',
  Category: 'Category',
  Description: 'Description',
  EKey: 'eKey',
  ETag: 'eTag',
  EndDate: 'EndDate',
  IsAllDayEvent: 'IsAllDayEvent',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Location: 'Location',
  MAJCOMCode: 'MAJCOMCode',
  RRule: 'RRule',
  SectionCode: 'SectionCode',
  ServicingOrganization: 'ServicingOrganization',
  StartDate: 'StartDate',
  Title: 'Title',
}

const LIST_NAME = 'CalendarEventsList'

const constructCalendarFilter = (args: CalendarFetchArgs): string => {
  const filters: string[] = []
  filters.push(isArchivedFilter(args.isArchived ?? null))
  if (args.assignedComponentFilter && args.assignedComponentFilter !== ALL_SELECT_VALUE) {
    filters.push(`(AssignedComponentCode eq ${args.assignedComponentFilter} or AssignedComponentCode eq null )` )
  }
  if(args.servicingMajcomFilter && args.servicingMajcomFilter !== ALL_SELECT_VALUE) {
    filters.push(`(MAJCOMCode eq ${args.servicingMajcomFilter} or MAJCOMCode eq null )`)
  }
  if(args.sectionFilter && args.sectionFilter !== ALL_SELECT_VALUE) {
    filters.push(`(SectionCode eq ${args.sectionFilter} or SectionCode eq null )`)
  }
  if(args.categoryFilter && args.categoryFilter !== ALL_SELECT_LABEL) {
    filters.push(`Category eq '${args.categoryFilter}'`)
  }
  const filter = and(...filters)
  return filter
}

const getCalendarEvents = async (
  args: CalendarFetchArgs
): Promise<Calendar[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructCalendarFilter(args)
  const items: any = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.AssignedComponentCode,
      COLUMN_NAMES.Category,
      COLUMN_NAMES.Description,
      COLUMN_NAMES.Location,
      COLUMN_NAMES.EKey,
      COLUMN_NAMES.ETag,
      COLUMN_NAMES.StartDate,
      COLUMN_NAMES.EndDate,
      COLUMN_NAMES.IsAllDayEvent,
      COLUMN_NAMES.IsArchived,
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy,
      COLUMN_NAMES.MAJCOMCode,
      COLUMN_NAMES.RRule,
      COLUMN_NAMES.SectionCode,
      COLUMN_NAMES.ServicingOrganization,
      COLUMN_NAMES.Title
    )
    .orderBy([{ ascending: args.isAscending ?? false, 
        orderBy: args.orderBy ?? COLUMN_NAMES.ItemModified }])
    .get()

  items.forEach((element: Calendar) => {
    element.AssignedComponentCode = element.AssignedComponentCode || ALL_SELECT_VALUE
    element.Category = element.Category || ALL_SELECT_LABEL
    element.MAJCOMCode = element.MAJCOMCode || ALL_SELECT_VALUE
    element.SectionCode = element.SectionCode || ALL_SELECT_VALUE
  })
  return [...items] as Calendar[]
}

export {
  COLUMN_NAMES,
  type Calendar,
  type CalendarFetchArgs,
  LIST_NAME,
  getCalendarEvents,
}
